export default [
  'jpg',
  'jpeg',
  'png',
];
